<template>
    <div
        class="logo-oem"
        data-cy="logo-oem">
        <pendo-router-link :to="{ name: 'DefaultDashboard' }">
            <img
                v-if="logoConfig.src"
                v-pendo-tooltip="{
                    content: logoConfig.alt,
                    arrow: true,
                    placement: 'bottom',
                }"
                :src="logoConfig.src"
                class="logo"
                data-cy="logo-oem-custom-image"
                :alt="logoConfig.alt">
            <div
                v-else
                class="default-logo-container"
                data-cy="logo-oem-default-container">
                <img
                    src="@img/pendo-chevron.svg"
                    height="64"
                    width="auto"
                    class="logo"
                    data-cy="logo-oem-default-image"
                    :alt="trainingAttributes.whiteLabelSettings?.brandName">
                {{ trainingAttributes.whiteLabelSettings?.brandName || 'OEM' }}
            </div>
        </pendo-router-link>
    </div>
</template>

<script>
import { PendoTooltip } from '@pendo/components-vue3';
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { mapState as mapPiniaState } from 'pinia';
import { useSubscriptionStore } from '@/stores/subscription.store';

export default {
    name: 'Logo',
    components: {
        PendoRouterLink,
    },
    directives: {
        PendoTooltip,
    },
    computed: {
        ...mapPiniaState(useSubscriptionStore, {
            trainingAttributes: 'trainingAttributes',
        }),
        logoConfig () {
            return {
                src: this.trainingAttributes.whiteLabelSettings?.logoUrl,
                alt: this.trainingAttributes.whiteLabelSettings?.brandName,
            };
        },
    },
};
</script>

<style scoped lang="less">
.logo-oem {
    display: flex;
    margin-bottom: 20px;
}

.default-logo-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;

    color: var(--text-body-default-base);
    font-family: 'Sora';
    font-size: 16px;
    font-weight: bold;
}

.logo {
    max-width: 144px;
    max-height: 56px;
    vertical-align: middle;

    &:focus-visible {
        outline: 2px solid var(--focus-ring-base);
        outline-offset: 4px;
    }
}
</style>
